<template>
  <section id="hero">
    <base-jumbotron
      :src="require('@/assets/Richmond-Blur-Small.jpg')"
      color="grey darken-4"
      dark
      height="100%"
      min-height="100vh"
    >
      <v-row
        align="center"
        class="pb-12"
      >
        <v-col
          cols="12"
          md="5"
        >
          <div>
            <base-title>
              Furries of Virginia
            </base-title>

            <v-divider class="mb-3" />

            <div class="subheading mb-4">
              <p>Welcome to the fun</p>
            </div>

            <v-btn
              color="primary"
              class="ma-0"
              @click="$router.push({name: 'Events'})"
              large
            >
              <v-icon left>
                mdi-calendar-multiple
              </v-icon>
              Checkout Our Events

            </v-btn>
          </div>
        </v-col>
      </v-row>
    </base-jumbotron>
  </section>
</template>

<script>
  export default {
    name: 'HomeHero',
  }
</script>
